import type TransitionScreenLegacyDialogType from '@atlassian/jira-common-components-transition-screen-legacy-dialog';

export const getTransitionScreenLegacyDialog = async (): Promise<
	typeof TransitionScreenLegacyDialogType
> => {
	const module = await import(
		/* webpackChunkName: "async-transition-screen-legacy-dialog" */ '@atlassian/jira-common-components-transition-screen-legacy-dialog'
	);
	return module.default;
};

export const transitionAndRankAction = 'jwm.board.transition-and-rank';
export const transitionAction = 'jwm.board.transition';
export const rankAction = 'jwm.board.rank';

export const JWM_BOARD_CARD_ISSUE_TRANSITION = 'jwm-board-card-issue-transition';
